import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { MasterService } from '@app/utility/master.service';
import { Subject, Subscription } from 'rxjs';
import { NotiService } from '@app/noti.service';

declare var $: any

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  config: any
  isCrisis = false

  top3news: any = []
  newsList: any = []

  carouselList: any = []

  menuList: any 

  lang = "th"

  simulateMenu: any = {}
  contactDpaMenu: any = {}
  faqMenu: any = {}
  loginMenu: any = {}
  trackStatusMenu: any = {}
  inquiryMenu: any = {}
  banklistMenu: any = {}

  private notiSubscription: Subscription;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private util: UtilService,
    private sanitizer: DomSanitizer,
    private MasterService: MasterService,
    private notiService: NotiService
  ) { }

  async ngOnInit() {

    this.util.ShowWaiting(true)

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
    });

    $("div.shadow-box").hover(
      function(){
        {
          $(this).attr("style", "background-color: var(--cust-blue); color: white !important;");
          var imgSrc = $(this).find("img").attr('src');
          var h = "-hover";
          var position = imgSrc.lastIndexOf('.')
          var newSrc = [imgSrc.slice(0, position), h, imgSrc.slice(position)].join('');
          $(this).find("img").attr('src', newSrc);
        }
      }, function(){
        {
          $(this).attr("style", "background-color: white; color: var(--cust-blue) !important;");
          var imgSrc = $(this).find("img").attr('src');
          var newSrc = imgSrc.replace("-hover", "");
          $(this).find("img").attr('src', newSrc);
        }
    });

    var carouselContainer = $('.carousel');
    var slideInterval = 5000;

    function toggleCaption(index: number) {
      // $('.carousel-caption-lbl').not('.carousel-caption-lbl' + index.toString()).animate({
      //   opacity: '0'
      // }, 5);
      // //$('.carousel-caption-lbl').fadeOut()
      // $('.carousel-caption-lbl' + index.toString()).animate({
      //   opacity: '1'
      // }, 1200);
    }

    this.config = await this.apiService.get("master", "configuration")
    let crisisConfig: any = this.config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.isCrisis = true
      //await this.getNews()
      $(".crisis").show()
      $(".not-crisis").hide()
    }
    else {
      this.isCrisis = false
      $(".not-crisis").show()
      $(".crisis").hide()
    }

    this.menuList = await this.apiService.get("master", "customerPortalMenuSetting")

    this.simulateMenu = this.getMenuObj("01")
    this.contactDpaMenu = this.getMenuObj("02")
    this.faqMenu = this.getMenuObj("03")
    this.loginMenu = this.getMenuObj("04")
    this.trackStatusMenu = this.getMenuObj("05")
    this.inquiryMenu = this.getMenuObj("06")
    this.banklistMenu = this.getMenuObj("07")

    if(this.simulateMenu.show){
      $(".simulateMenu").show()
    }
    else{
      $(".simulateMenu").hide()
    }
    if(this.contactDpaMenu.show){
      $(".contactDpaMenu").show()
    }
    else{
      $(".contactDpaMenu").hide()
    }
    if(this.faqMenu.show){
      $(".faqMenu").show()
    }
    else{
      $(".faqMenu").hide()
    }
    if(this.trackStatusMenu.show){
      $(".trackStatusMenu").show()
    }
    else{
      $(".trackStatusMenu").hide()
    }
    if(this.inquiryMenu.show){
      $(".inquiryMenu").show()
    }
    else{
      $(".inquiryMenu").hide()
    }

    $(".news-menu").show()

    this.carouselList = await this.MasterService.GetCarousel(this.isCrisis)

    
    carouselContainer.carousel({
      interval: slideInterval,
      cycle: true,
      pause: "false"
    }).on('slid.bs.carousel', function (e: any) {
      var index = $(e.relatedTarget).index();
      toggleCaption(index);
    });
    
    // $(".carousel-caption-lbl0").animate({
    //   opacity: '1'
    // }, 2000);

    
    //this.menuList = await this.apiService.get("master", "customerPortalMenuSetting")
    
    this.util.ShowWaiting(false)

  }

  ngOnDestroy() {
    this.notiSubscription.unsubscribe();
}

  goToNews() {
    this.router.navigate(["/mainmenu/allNews"])
  }

  goToContactDpa() {
    this.router.navigate(["/mainmenu/contactDPA"])
  }

  goToFaq() {
    //this.router.navigate(["/mainmenu/faq"])
    let url = 'https://www.dpa.or.th/';
    window.open(url, "_blank")
  }

  goToStatusTracking(){
    this.router.navigate(["/mainmenu/statusTracking"])
  }

  goToRefundDeposits(){
    this.router.navigate(["/mainmenu/refundDeposits"])
  }

  goToSimulate(){
    this.router.navigate(["/mainmenu/simulate"])
  }

  async getNews() {

    let para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.isCrisis.toString()
    this.newsList = await this.apiService.get("crmservice", "news", para)

    this.newsList.forEach((n: any) => {
      let news: string =
        `<a class="text-primary mr-5" target="_blank" href="/news/` + n.dpa_newandactivityid + `">
          <span class="fa fa-newspaper mr-2"></span>` + n.dpa_name + `
        </a>`

      $(".marquee").append(news)
    });


    $('.marquee').marquee({
      duration: 25000,
      //gap in pixels between the tickers
      gap: 50,
      //time in milliseconds before the marquee will start animating
      delayBeforeStart: 0,
      //'left' or 'right'
      direction: 'left',
      //true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: false,

      pauseOnHover: true
    });

  }

  sanitize(str: string) {
    return this.sanitizer.bypassSecurityTrustStyle(str);
  }

  async GetLangChanged(_lang: string) {
    this.lang = _lang
  }

  getMenuObj(code: string){
    if(this.menuList != null && this.menuList.length > 0) {
      let menuObj: any = this.menuList.filter((m: any) => {
        return m.dpa_code == code
      })
      if(menuObj != null && menuObj.length > 0){
        if(menuObj[0].dpa_enabledisable == false){
          menuObj[0].show = false
        }
        else if(menuObj[0].dpa_isdisplay == 3){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 1 && !this.isCrisis){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 2 && this.isCrisis){
          menuObj[0].show = true
        }
        else{
          menuObj[0].show = false
        }
        
        return menuObj[0]
      }
      else{
        return {}
      }
    }
    else{
      return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/index/index.component.ts